import { useRef } from 'react';
import { MenuProps } from 'types';
import { useOnClickOutside } from '../../hooks';

export const useComponentLogic = ({
	close,
	shouldCloseOnClickOutside,
}: MenuProps) => {
	const ref = useRef(null);
	useOnClickOutside(ref, close, shouldCloseOnClickOutside);
	return { ref };
};
